// Generated by Melange

import * as Buhta_cabinet__Kassa from "../../../../grpc/Kassa.js";
import * as Buhta_cabinet__OrgDashboardHeaderMobile from "../../../molecules/OrgDashboardHeader/OrgDashboardHeaderMobile.js";
import * as Buhta_core__GrpcState from "../../../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Toast from "../../../../../../../packages/core/lib/Toast.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as ReactCopyToClipboard from "react-copy-to-clipboard";
import * as JsxRuntime from "react/jsx-runtime";

function ReceiptHeader(Props) {
  let id = Props.id;
  let receiptId = Props.receiptId;
  let openMenu = Props.openMenu;
  let closeReceiptButton = Props.closeReceiptButton;
  const match = Buhta_core__Toast.ToastsContext.useToasts(undefined);
  const dispatchToasts = match[1];
  const func = Buhta_cabinet__Kassa.ReceiptService.view;
  const match$1 = Buhta_core__GrpcState.useModel((function (param) {
    return Curry._4(func, param, id, /* [] */ 0, receiptId);
  }), undefined);
  const dispatch = match$1[1];
  const receipt = match$1[0];
  React.useEffect((function () {
    Curry._2(dispatch, undefined, undefined);
  }), [
    id,
    receiptId
  ]);
  const receiptTitle = typeof receipt === "string" || receipt.NAME !== "Data" ? "Чек" : "Чек №" + String(receipt.VAL.serial_id);
  const match$2 = React.useState(function () {
    return "";
  });
  const setHost = match$2[1];
  React.useEffect((function () {
    Curry._1(setHost, (function (param) {
      return window.location.protocol + ("//" + window.location.host);
    }));
  }), []);
  const receiptButtons = JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsx(ReactCopyToClipboard.CopyToClipboard, {
        text: match$2[0] + ("/receipt/" + (String(id) + ("/" + receiptId))),
        onCopy: (function (param) {
          Curry._1(dispatchToasts, {
            TAG: /* Add */ 0,
            _0: {
              id: Buhta_core__Toast.generateId(undefined),
              text: "Ссылка скопирована",
              kind: "success",
              onClick: (function (param) {
                
              })
            }
          });
        }),
        children: JsxRuntime.jsx("img", {
          className: "w-5 h-5 cursor-pointer",
          src: StaticAsset.src("/static/icons/link.svg")
        })
      }),
      JsxRuntime.jsx("a", {
        children: JsxRuntime.jsx("img", {
          className: "w-5 h-5",
          src: StaticAsset.src("/static/icons/share.svg")
        }),
        href: "/receipt/" + (String(id) + ("/" + receiptId)),
        target: "_blank"
      })
    ]
  });
  return JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeaderMobile.make, {
    title: receiptTitle,
    leftChildren: closeReceiptButton,
    openMenu: openMenu,
    rightChildren: receiptButtons,
    showMenu: false
  });
}

const make = ReceiptHeader;

export {
  make,
}
/* Buhta_cabinet__Kassa Not a pure module */
